import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';
import PAA from '../../blocks/PhoneAndAddress';
import Title from '../../blocks/Title'
import MyIcons from '../../blocks/MyIcons'
import ArrowScroll from '../../blocks/ArrowScroll'
import {LangChangeEventContext} from '../../contexts/LangContext';



export default class MainHistory extends Component {
  componentWillMount(){
    
  }
  componentDidMount(){
    this.props.getHeightHistory(this.historyBody.offsetHeight);
  }
  handleScrollDown = () =>{
    this.props.handleScrollDown();
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
          <div className={classNames(styles['historyBody'], 
              this.props.steps[1] && styles['is-step1'], 
              this.props.steps[2] && styles['is-step2'], 
              this.props.steps[3] && styles['is-step3'], 
              this.props.steps[4] && styles['is-step4'], 
              this.props.steps[5] && styles['is-step5'], 
              this.props.steps[6] && styles['is-step6'], 
              this.props.steps[7] && styles['is-step7'], 
              this.props.steps[8] && styles['is-step8'],
              this.props.steps[9] && styles['is-step9'], 
              this.props.hideArrow && styles['hide-arrow'])
            } 
            ref={item => {this.historyBody = item}}
          > 
            <div className={classNames(styles['backgroundImgWrapper'])} >
              <img alt="" src={this.props.ADMIN_URL+this.props.bg} className={styles['backgroundImg']} />
            </div>

            <div className={classNames(styles['contentWrapper'])}>
              <div className={classNames(styles['header'])}>
                <PAA classStyle={styles['paaStyle']} iconPlace='place' iconPhone='phone' colorStyle="black"/>
                <Title colorStyle="black" classStyle={styles['titleStyle']} title={lang.t('historyHeader')} text={lang.t('historySubHeader')} />
              </div>
              <div className={classNames(styles['content'])}>
                <div className={styles['wrapperText']} >  
                  <h3 className={styles['wrapperTextTitle']}>{lang.t('historyTitle')}</h3>
                  <div className={styles['text']} >  
                    {lang.t('historyText1')}
                  </div>
                  <div className={styles['textGallery']} >
                    {JSON.parse(this.props.gallery2).map( (img,i) => {
                      return(
                        <div className={styles['imgWr']} key={i} >
                          <img className={styles['img']}  alt="" src={this.props.ADMIN_URL+img.image} />
                        </div>
                      )
                    })}
                  </div>
                  <div className={styles['text']} >  
                    {lang.t('historyText2')} 
                  </div>
                  <div className={styles['spoon']} >  
                    <MyIcons icon="spoon" width="100px" height="100px"/>
                  </div>
                </div>              
                <div className={styles['gallery']} >
                  {JSON.parse(this.props.gallery1).map( (img,i) => {
                    return(
                      <div className={styles['galleryImgWrapper']} key={i} >
                        <img alt="" src={this.props.ADMIN_URL+img.image} className={styles['galleryImg']} />
                      </div>
                    )
                  })}
                </div>
              </div>

              

            </div>
            
            <div className={styles['arrowWrapper']} onClick={this.handleScrollDown}>
              <ArrowScroll/>
            </div>

          </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/MainHistory/index.js